export type Query = Record<
	string,
	string | number | boolean | ReadonlyArray<string> | null | undefined
>;

/** `VITE_API_URL` may or may not already end in `/api` (learning: double-prefix bug); this yields exactly one. */
export const apiRoot = (base: string): string =>
	`${base.replace(/\/+$/, "").replace(/\/api$/, "")}/api`;

/** Skips null, undefined, "" and empty arrays, matching v1's `buildUrl`. */
export const buildUrl = (base: string, path: string, query?: Query): string => {
	const params = new URLSearchParams();
	for (const [key, value] of Object.entries(query ?? {})) {
		if (value == null || value === "") continue;
		if (Array.isArray(value)) {
			for (const entry of value) if (entry !== "") params.append(key, entry);
		} else {
			params.append(key, String(value));
		}
	}
	const search = params.toString();
	return `${apiRoot(base)}${path}${search ? `?${search}` : ""}`;
};
